/* =============================================================================
   assets/bb-cart-cp.js — Bloom-Bloom: το συρταρι = η σελιδα /cart (17/10/2026, 2η φαση)
   -----------------------------------------------------------------------------
   Φορτωνεται απο το sections/cart-drawer.liquid (defer, πριν το bb-cart.js). Δουλευει μονο
   οταν το <cart-drawer> εχει data-bb-cp (snippets/cart-drawer.liquid).

   1. renderContents() του <cart-drawer> (το καλει το product-form.js μετα το ΠΡΟΣΘΗΚΗ και το
      cart-drawer.js στο refresh): ΟΧΙ ολοκληρο ξαναγραψιμο του συρταριου — μονο οι ζωνες
      (<cart-items>, #cart-promoted-products, .cart-drawer__summary, #cart-drawer-media-promotion,
      #cart-icon-bubble), οπως κανει το cart-items.js στο +/−. Ετσι το app block της BOX NOW
      (χαρτης, επιλεγμενο locker) και το μηνυμα του πελατη ΔΕΝ χανονται με καθε προσθηκη.
   2. BOX NOW μεσα στο συρταρι: γραμμη «Παραλαβη με BOX NOW locker» που ανοιγει τον χαρτη της BOX NOW
      σε ολο το συρταρι· χωρα ΑΥΤΟΜΑΤΑ απο το snippets/bb-geo.liquid (CY → Κυπρος, αλλιως Ελλαδα)·
      η επιλογη γραφεται στα cart attributes boxnow_locker_* (βλ. παρακατω).
   ============================================================================= */
(function () {
  'use strict';
  if (window.__bbCartCp) { return; }
  window.__bbCartCp = true;

  function drawer() { return document.getElementById('cart-drawer'); }
  function cpMode(d) { d = d || drawer(); return !!(d && d.hasAttribute('data-bb-cp')); }
  function sectionIdOf(d) {
    try { var s = d && d.closest('.shopify-section'); return s && s.id ? s.id.replace('shopify-section-', '') : ''; } catch (e) { return ''; }
  }
  function pick(html, selector) {
    var tmpl = document.createElement('template');
    tmpl.innerHTML = html || '';
    var el = tmpl.content.querySelector(selector);
    return el ? el.innerHTML : '';
  }

  /* ---------- 1. ζωνες αντι για ολοκληρο ξαναγραψιμο ---------- */
  function renderZones(d, sections) {
    var sid = sectionIdOf(d);
    var html = sections && sections[sid];
    if (!html) { return false; }
    var tmpl = document.createElement('template');
    tmpl.innerHTML = html;
    var src = tmpl.content;
    var map = [
      ['cart-items', 'cart-items'],
      ['cart-promoted-products', '#cart-promoted-products'],
      ['cart-drawer', '.cart-drawer__summary'],
      ['cart-drawer-media-promotion', '#cart-drawer-media-promotion']
    ];
    for (var i = 0; i < map.length; i++) {
      var target = document.getElementById(map[i][0]);
      if (!target) { continue; }
      var el = target.querySelector(map[i][1]) || (target.matches(map[i][1]) ? target : null);
      var fresh = src.querySelector(map[i][1]);
      if (el && fresh) {
        el.innerHTML = fresh.innerHTML;
        if (el.tagName === 'CART-ITEMS' && fresh.hasAttribute('data-empty')) { el.setAttribute('data-empty', fresh.getAttribute('data-empty')); }
      }
    }
    /* 17/10/2026 (test ιδιοκτητη): με ΑΔΕΙΟ καλαθι στη φορτωση, η 1η ΠΡΟΣΘΗΚΗ εγραφε μονο το περιεχομενο —
       το .cart-drawer__summary εμενε με την κλαση bb-ft--empty (display:none στο bb-cart.css → χωρις ΣΥΝΟΛΟ/ΤΑΜΕΙΟ)
       και το μηνυμα (εκτος ζωνων) εμενε κρυφο και κενο. Τωρα: κλασεις απο τη φρεσκια εκδοση + γεμισμα μηνυματος
       (μονο αν δεν εχει ηδη textarea, για να μη χαθει οτι εγραψε ο πελατης). */
    var ft = d.querySelector('.cart-drawer__summary'), fft = src.querySelector('.cart-drawer__summary');
    if (ft && fft) { ft.className = fft.className; }
    var nt = d.querySelector('.bb-cpd__note'), fnt = src.querySelector('.bb-cpd__note');
    if (nt && fnt) {
      if (!nt.querySelector('textarea')) { nt.innerHTML = fnt.innerHTML; }
      if (fnt.hasAttribute('hidden')) { nt.setAttribute('hidden', ''); } else { nt.removeAttribute('hidden'); }
    }
    var ci = d.querySelector('cart-items');
    var empty = !!(ci && ci.getAttribute('data-empty') === 'true');
    /* το <cart-items> που γεννηθηκε αδειο δεν εχει listeners (ο constructor του cart-items.js
       καλει init() μονο με data-empty=false) — τωρα που γεμισε, τους βαζουμε */
    if (ci && !empty && typeof ci.init === 'function' && !ci.fetchRequestOpts) { try { ci.init(); } catch (x) { /* noop */ } }
    var ls = d.querySelector('.bb-ls');
    if (ls) {
      ls.classList.toggle('bb-ls--empty', empty);
      if (!empty) { ls.classList.remove('drawer__content--flex', 'grow', 'flex', 'items-center', 'drawer__empty-with-promotions'); }
    }
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) { bubble.innerHTML = pick(sections['cart-icon-bubble'], '.shopify-section'); }
    d.classList.remove('bb-ghosting');
    return true;
  }
  function patch(d) {
    if (!d || d.__bbCpPatched || !cpMode(d)) { return; }
    d.__bbCpPatched = true;
    var orig = d.renderContents;
    d.renderContents = function (data, openDrawer) {
      var sections = data && data.sections;
      var ok = false;
      try { ok = renderZones(d, sections); } catch (x) { ok = false; }
      if (!ok && typeof orig === 'function') { return orig.call(d, data, openDrawer); }
      if (openDrawer !== false && d.getAttribute('open') === null) {
        setTimeout(function () { try { d.open(); } catch (x) { document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open')); } });
      }
      try { d.dispatchEvent(new CustomEvent('bb:cp:rendered', { bubbles: true })); } catch (x) { /* noop */ }
      return Promise.resolve();
    };
  }

  /* ---------- 2. BOX NOW μεσα στο συρταρι: γραμμη «Παραλαβη με BOX NOW locker» → χαρτης ----------
     Το πατημα στη γραμμη (.bb-bnrow, data-bb-bn-open) ανοιγει το #bb-bnmap (ολο το συρταρι) με τον χαρτη
     της BOX NOW: iframe widget-v5.boxnow.<gr|cy>/iframe.html — η χωρα ΑΥΤΟΜΑΤΑ απο το bb-geo
     (html[data-bb-geo]="CY" → Κυπρος, αλλιως Ελλαδα). Ιδιο URL/παραμετροι με την εφαρμογη BOX NOW στη
     σελιδα /cart (autoselect=yes&autoclose=no: «πατας locker = το διαλεξες»).
     Ο χαρτης στελνει postMessage {boxnowLockerId, boxnowLockerName, boxnowLockerAddressLine1/2,
     boxnowLockerPostalCode, boxnowCountry} ή {boxnowClose:"yes"} (Χ του widget). Μολις ερθει locker:
     η γραμμη δειχνει «✓ ονομα · Αλλαγη» αμεσως, ο χαρτης κλεινει, και τα cart attributes
     boxnow_locker_address / _name / _id / _country γραφονται με /cart/update.js — ΤΑ ΙΔΙΑ που γραφει η
     εφαρμογη BOX NOW (τα διαβαζει για την αποστολη). Αν το /cart/update.js αποτυχει: «Δεν αποθηκευτηκε».
     ΔΕΝ χρειαζεται ουτε φορτωνεται το v5.js / app embed της BOX NOW. */
  var BN_PARTNER = 7471; /* partnerId του καταστηματος στη BOX NOW (ιδιο με το app) */
  function geoCc() { return document.documentElement.getAttribute('data-bb-geo') === 'CY' ? 'cy' : 'gr'; }
  function boxnow(d) {
    if (d.__bbBn) { return; }
    var map = d.querySelector('#bb-bnmap');
    var frame = map && map.querySelector('[data-bb-bn-frame]');
    if (!map || !frame) { return; }
    d.__bbBn = true;
    var openCc = 'gr';

    function row() { return d.querySelector('.bb-bnrow'); }
    function setRow(state, name) {
      var r = row();
      if (!r) { return; }
      r.classList.toggle('is-set', state === 'set');
      r.classList.toggle('is-err', state === 'err');
      var n = r.querySelector('[data-bb-bn-name]');
      if (n && state === 'set') { n.textContent = name || ''; }
    }
    function isOpen() { return !map.hidden; }
    function open() {
      openCc = geoCc();
      frame.innerHTML = '';
      var f = document.createElement('iframe');
      f.className = 'bb-bnmap__if';
      f.title = 'BOX NOW lockers';
      f.setAttribute('allow', 'geolocation');
      f.src = 'https://widget-v5.boxnow.' + openCc + '/iframe.html?partnerId=' + BN_PARTNER + '&gps=yes&autoselect=yes&autoclose=no&language=el';
      frame.appendChild(f);
      map.hidden = false;
      d.classList.add('bb-bn-open');
      try { map.querySelector('[data-bb-bn-close]').focus({ preventScroll: true }); } catch (x) { /* noop */ }
    }
    function close() {
      if (!isOpen()) { return; }
      map.hidden = true;
      d.classList.remove('bb-bn-open');
      frame.innerHTML = '';
      try { var r = row(); if (r) { r.focus({ preventScroll: true }); } } catch (x) { /* noop */ }
    }
    function save(m) {
      var id = String(m.boxnowLockerId);
      var name = String(m.boxnowLockerName || '');
      var addr = [m.boxnowLockerAddressLine1, m.boxnowLockerAddressLine2, m.boxnowLockerPostalCode]
        .map(function (v) { return v == null ? '' : String(v); }).join(', ');
      setRow('set', name);
      close();
      var fd = new FormData();
      fd.append('attributes[boxnow_locker_address]', addr);
      fd.append('attributes[boxnow_locker_name]', name);
      fd.append('attributes[boxnow_locker_id]', id);
      fd.append('attributes[boxnow_locker_country]', openCc.toUpperCase());
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/update.js', { method: 'POST', body: fd, credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
        .then(function (c) {
          if (!c || !c.attributes || String(c.attributes.boxnow_locker_id || '') !== id) { throw new Error('not saved'); }
        })
        .catch(function () { setRow('err'); });
    }

    /* ανοιγμα / κλεισιμο (delegation: η γραμμη ειναι εκτος ζωνων, αλλα ετσι αντεχει και σε ξαναγραψιμο) */
    d.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) { return; }
      if (t.closest('[data-bb-bn-open]')) { e.preventDefault(); open(); return; }
      if (t.closest('[data-bb-bn-close]')) { e.preventDefault(); e.stopPropagation(); close(); }
    });
    /* Esc: κλεινει πρωτα τον χαρτη (οχι ολο το συρταρι) */
    ['keydown', 'keyup'].forEach(function (type) {
      window.addEventListener(type, function (e) {
        if (!isOpen() || (e.key !== 'Escape' && e.key !== 'Esc')) { return; }
        e.stopPropagation();
        e.preventDefault();
        if (type === 'keyup') { close(); }
      }, true);
    });
    /* το συρταρι κλεινει → κλεινει και ο χαρτης */
    if ('MutationObserver' in window) {
      new MutationObserver(function () { if (d.getAttribute('open') === null) { close(); } })
        .observe(d, { attributes: true, attributeFilter: ['open'] });
    }
    window.addEventListener('message', function (e) {
      if (!isOpen()) { return; }
      if (!/^https:\/\/[a-z0-9-]+\.boxnow\.[a-z]{2,}$/i.test(String(e.origin))) { return; }
      var m = e.data;
      if (typeof m === 'string') { try { m = JSON.parse(m); } catch (x) { return; } }
      if (!m || typeof m !== 'object') { return; }
      if (m.boxnowClose === 'yes') { close(); return; }
      if (m.boxnowLockerId) { save(m); }
    });
  }

  function init() {
    var d = drawer();
    if (!d || !cpMode(d)) { return; }
    patch(d);
    boxnow(d);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
  /* το cart-drawer.js οριζει το custom element αργοτερα (defer) — το instance method μας μενει πανω απο το prototype */
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
